import React from "react";
import profile from "../assets/profile.jpg";
import resume from "../assets/Teja-Praveen-Resume.pdf";
import { FaLinkedin, FaGithub } from "react-icons/fa";
import "./Hero.css";

export default function Hero() {
  return (
    <section className="hero" id="home">
      <div className="hero-left">
        <img src={profile} alt="Teja Praveen" className="profile-img" />
      </div>
      <div className="hero-right">
        <p className="intro">Hello I'm</p>
        <h1 className="hero-name">Teja Praveen Deva Raju Obulasetty</h1>
        <p className="hero-role">
          Aspiring Software Engineer withstrong foundational knowledge in web
          development, Java, and SQL. Seeking an opportunity to contribute to an
          innovative team and leverage my skills to develop high-quality
          software solutions.{" "}
        </p>

        <div className="hero-buttons">
          <a href={resume} download className="btn">
            Download CV
          </a>
          <a href="#contact" className="btn outline">
            Contact
          </a>
        </div>

        <div className="hero-icons">
          <a
            href="https://www.linkedin.com/in/obulasetty-teja-praveen-deva-raju-39a669259/"
            target="_blank"
            rel="noreferrer"
          >
            <FaLinkedin />
          </a>
          <a
            href="https://github.com/TEJAPRAVEENDEVARAJU"
            target="_blank"
            rel="noreferrer"
          >
            <FaGithub />
          </a>
        </div>
      </div>
    </section>
  );
}
